import React from "react";

const CopyIcon = ({ color = "#292D32" }) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#clip0_63955_139502)"
        stroke="#475467"
        strokeWidth={1.125}
        strokeLinejoin="round"
      >
        <path d="M6.75 16.5V6.75l9.75.006V16.5H6.75z" strokeLinecap="round" />
        <path d="M12.75 6.75V1.507L1.5 1.5v11.25h5.25" />
      </g>
      <defs>
        <clipPath id="clip0_63955_139502">
          <path fill="#fff" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CopyIcon;
